import { Button } from "@/components";
import { AMENITY_GROUP, useBookingRecoilValue } from "@/shared/client";
import { type RoomType } from "@/shared/server";
import { FONT } from "@/styles";
import { Box, Center, Flex, Image, Spinner, Text } from "@chakra-ui/react";
import DOMPurify from "dompurify";

export const RoomInfos = ({ targetRoomIdx, rooms }: { targetRoomIdx: number; rooms: RoomType[] }) => {
    const bookingURL = useBookingRecoilValue();

    const targetRoom = rooms.find((t) => t.room_idx === String(targetRoomIdx));

    const activeAmenities = AMENITY_GROUP.filter(
        ({ name }) => targetRoom?.amenity_icon[name as keyof typeof targetRoom.amenity_icon],
    );
    const onLink = (url: string) => {
        if (bookingURL.includes("http")) {
            window.open(url, "_blank");
        }
        if (!bookingURL.includes("http")) {
            window.open(`https://${url}`, "_blank");
        }
    };
    return targetRoom ? (
        <Flex flexDir="column">
            <Flex gap="32px">
                <Flex flexDir="column" alignItems="flex-end" gap="24px">
                    <Box
                        w="592px"
                        h="432px"
                        bg={
                            targetRoom.imgList[0]
                                ? `url(${targetRoom.imgList[0].img_URL})no-repeat center/cover`
                                : "gray.100"
                        }
                    />
                    <Box>
                        <Button
                            w="auto !important"
                            h="48px !important"
                            sizeType="large"
                            roundType="none"
                            backgroundType="navy"
                            borderType="navy"
                            onClick={() => onLink(bookingURL)}
                        >
                            예약하기
                        </Button>
                    </Box>
                </Flex>
                <Flex
                    flex="1"
                    flexDir="column"
                    gap="16px"
                    sx={{
                        "& div > p:first-of-type": {
                            color: "#3b6c8d",
                            marginBottom: "8px",
                            ...FONT("notoSerif", 14, 400, 1.4),
                        },
                        "& div > p:nth-of-type(2)": {
                            color: "#6b6b6b",
                            ...FONT("pretendard", 16, 300, 1.4),
                        },
                        "& div:last-of-type > p:nth-of-type(2)": {
                            ...FONT("pretendard", 14, 300, 1.4),
                            color: "#333",
                        },
                        "& > div:first-of-type > p:first-of-type": {
                            ...FONT("notoSerif", 24, 400, 1.4),
                        },
                    }}
                >
                    <Box>
                        <Text>{targetRoom.room_name}</Text>
                        <Text dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(targetRoom.room_intro) }} />
                    </Box>
                    <Box>
                        <Text>Room Type</Text>
                        <Text>{targetRoom.room_type}</Text>
                    </Box>
                    <Box>
                        <Text>Number of People</Text>
                        <Text>
                            기준{targetRoom.people.min}인 ~ 최대
                            {targetRoom.people.max}인
                        </Text>
                    </Box>
                    <Box>
                        <Text>Size</Text>
                        <Text>{targetRoom.room_size}㎡</Text>
                    </Box>
                    <Box>
                        <Text>Facilities</Text>
                        <Flex mt="8px">
                            {activeAmenities.map(({ name, url }) => (
                                <Box
                                    key={name}
                                    w="48px"
                                    h="48px"
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    borderRadius="md"
                                    bg="rgba(255,255,255,0.1)"
                                >
                                    <Image src={url} alt={name} w="100%" h="100%" objectFit="contain" />
                                </Box>
                            ))}
                        </Flex>
                        <Text mt="8px">{targetRoom.amenity}</Text>
                    </Box>
                </Flex>
            </Flex>
        </Flex>
    ) : (
        <Center h="100%">
            <Text>Loading...</Text>
            <Spinner />
        </Center>
    );
};
